import React, { useEffect, useState } from 'react';

import {
  CONSULTANCY_VALIDATION_SUPPORT_TYPES,
  CONSULTANCY_OTHER_ON_DEMAND_SERVICES_TYPES
} from '../../../SurveyBuilder/helpers/constants';

import Icon from '../../../SurveyBuilder/components/Icon/Icon';

import styles from './SurveyDetails.module.css';

export default ({
  survey,
  updateConfirmationStatus,
  allowedToChangeConfirmSurveyDetails,
  adminNeedsToConfirmDetails
}) => {
  const [surveyDetailsConfirmed, setSurveyDetailsConfirmed] = useState(
    survey && survey.surveyDetailsConfirmed
  );
  const [
    surveyDetailsConfirmedByAdmin,
    setSurveyDetailsConfirmedByAdmin
  ] = useState(survey && survey.surveyDetailsConfirmedByAdmin);

  useEffect(
    () => {
      if (
        survey &&
        survey.surveyDetailsConfirmedByAdmin &&
        !surveyDetailsConfirmedByAdmin
      ) {
        setSurveyDetailsConfirmedByAdmin(true);
      }
    },
    [survey]
  );

  const CONSULTANCY_VALIDATION_SUPPORT_MAPPING_SHORT = {
    [CONSULTANCY_VALIDATION_SUPPORT_TYPES.NONE]: 'None',
    [CONSULTANCY_VALIDATION_SUPPORT_TYPES.MINI_SUPPORT]:
      'Mini validation support',
    [CONSULTANCY_VALIDATION_SUPPORT_TYPES.LIGHT_SUPPORT]:
      'Light validation support',
    [CONSULTANCY_VALIDATION_SUPPORT_TYPES.FULL_SUPPORT]:
      'Full validation support'
  };

  const CONSULTANCY_OTHER_ON_DEMAND_SERVICES_MAPPING_SHORT = {
    [CONSULTANCY_OTHER_ON_DEMAND_SERVICES_TYPES.DECISION_EXPERT_SUPPORT]:
      'Decision expert support',
    [CONSULTANCY_OTHER_ON_DEMAND_SERVICES_TYPES.TRANSLATION_PROJECT_MANAGEMENT]:
      'Translation & project management',
    [CONSULTANCY_OTHER_ON_DEMAND_SERVICES_TYPES.MULTI_COUNTRY_SETUP]:
      'Multi country set-up',
    [CONSULTANCY_OTHER_ON_DEMAND_SERVICES_TYPES.MULTI_COUNTRY_ANALYSIS]:
      'Multi country analysis'
  };

  const returnSurveyDetails = s => [
    {
      name: 'Customer',
      value:
        (s.recordDetails &&
          s.recordDetails.parent &&
          s.recordDetails.parent.name) ||
        (s.recordDetails && s.recordDetails.name) ||
        '-'
    },
    {
      name: 'Initiative',
      value:
        s.recordDetails && s.recordDetails.name && s.recordDetails.parent
          ? s.recordDetails.name
          : '-'
    },
    {
      name: 'Credits charged',
      value: s.translationOfOtherSurvey ? 'No' : 'Yes'
    },
    {
      name: 'Sample size',
      value: s.maxResponses || 0
    },
    {
      name: 'Survey questions',
      value: s.longestQuestionsPathCount || 0
    },
    {
      name: 'Estimated IR',
      value: s.totalIncidenceRate
        ? `${parseFloat(s.totalIncidenceRate * 100).toFixed(0)}%`
        : '0%'
    },
    {
      name: 'Validation support',
      value:
        s.additionalBudgetCost &&
        s.additionalBudgetCost.consultancy &&
        s.additionalBudgetCost.consultancy.validationSupport
          ? CONSULTANCY_VALIDATION_SUPPORT_MAPPING_SHORT[
              s.additionalBudgetCost.consultancy.validationSupport
            ]
          : 'None'
    },
    {
      name: 'Other on demand services',
      value:
        s.additionalBudgetCost &&
        s.additionalBudgetCost.consultancy &&
        s.additionalBudgetCost.consultancy.otherOnDemandServices &&
        s.additionalBudgetCost.consultancy.otherOnDemandServices.length
          ? s.additionalBudgetCost.consultancy.otherOnDemandServices.reduce(
              (acc, curr) => {
                if (acc.length) {
                  return `${acc} \n ${
                    CONSULTANCY_OTHER_ON_DEMAND_SERVICES_MAPPING_SHORT[curr]
                  }`;
                }
                return CONSULTANCY_OTHER_ON_DEMAND_SERVICES_MAPPING_SHORT[curr];
              },
              ''
            )
          : 'None'
    }
  ];

  return (
    <div className={styles.container}>
      {returnSurveyDetails(survey).map(property => (
        <div className={styles.row}>
          <span>{property.name}</span>
          <span className={styles.value}>{property.value}</span>
        </div>
      ))}
      <div
        className={`${styles.confirmContainer} ${
          !allowedToChangeConfirmSurveyDetails
            ? styles.confirmContainerDisabled
            : ''
        }`}
      >
        <div
          className={styles.checkboxContainer}
          onClick={() => {
            if (allowedToChangeConfirmSurveyDetails) {
              const newConfirmValue = adminNeedsToConfirmDetails
                ? !surveyDetailsConfirmedByAdmin
                : !surveyDetailsConfirmed;

              if (adminNeedsToConfirmDetails) {
                setSurveyDetailsConfirmedByAdmin(newConfirmValue);
                updateConfirmationStatus(
                  'surveyDetailsConfirmedByAdmin',
                  newConfirmValue
                );
              } else {
                setSurveyDetailsConfirmed(newConfirmValue);
                updateConfirmationStatus(
                  'surveyDetailsConfirmed',
                  newConfirmValue
                );
              }
            }
          }}
          role="presentation"
        >
          <Icon
            type={
              (adminNeedsToConfirmDetails
              ? surveyDetailsConfirmedByAdmin
              : surveyDetailsConfirmed)
                ? 'checkboxChecked'
                : 'checkboxUnChecked'
            }
          />
        </div>
        <span className={styles.confirmLabel}>
          By checking this box I confirm to have checked all of the above
        </span>
      </div>
    </div>
  );
};
